import { render, staticRenderFns } from "./CarrierPaymentsReviewHost.vue?vue&type=template&id=5577f0a6&"
import script from "./CarrierPaymentsReviewHost.vue?vue&type=script&lang=js&"
export * from "./CarrierPaymentsReviewHost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports